import {Pipe, PipeTransform} from '@angular/core';
import {LocalizationService} from '../services/localization.service';
import {Observable, of} from 'rxjs';
import {SupportedGenderEnum, VoiceBotGender, voiceBotGenders} from '../models/voice-bot.model';

@Pipe({
    name: 'i18nVoiceBotGender',
    standalone: false
})

export class I18nVoiceBotGenderPipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) {
    }

    transform(gender: string): Observable<string> {
        const voiceBotGender = voiceBotGenders?.find((voiceBotGender: VoiceBotGender) => {
            return voiceBotGender.shortName === gender as SupportedGenderEnum;
        });

        if (!!voiceBotGender?.i18nKey) {
            return this.localizationService.getTranslationByKeyAsync(voiceBotGender.i18nKey);
        } else {
            return of(gender);
        }
    }
}
